import React from 'react';

import * as Styled from 'shiftNotes/styles/NotesStack.style';

interface StepProgressDotsProps {
  currentStep: number;
  totalSteps: number;
  stepsCompletedStatus: boolean[];
}

export default function StepProgressDots({
  currentStep,
  totalSteps,
  stepsCompletedStatus,
}: StepProgressDotsProps): JSX.Element {
  const dots = Array.from({ length: totalSteps }, (_, i) => i + 1);
  return (
    <Styled.ProgressDotTrack
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={totalSteps}
      aria-valuenow={currentStep}
    >
      {dots.map((step) => {
        const isActive = step === currentStep;
        const isCompleted = stepsCompletedStatus[step - 1] ?? false;
        return (
          <Styled.ProgressDotSlot key={step} $active={isActive}>
            <Styled.ProgressDot $completed={isCompleted} $active={isActive} />
          </Styled.ProgressDotSlot>
        );
      })}
    </Styled.ProgressDotTrack>
  );
}
